import React from 'react';
import './notification-card.scss';

export interface Notification {
  id: number;
  icon: string;
  title: string;
  datetime: string;
  text: string;
}

type Props = {
  notifications: Notification[];
  onClose: () => void;
};

export const NotificationCard: React.FC<Props> = ({ notifications, onClose }) => {
  return (
    <div className="notification-card">
      <div className="notification-header">
        Notifications
        <img src={'/icons/close.svg'} alt="Close Button" className="close-icon" onClick={onClose}/>
      </div>
      <div className="notification-list">
        {notifications.map(notification => (
          <div key={notification.id} className="notification-item">
            <img src={notification.icon} alt="Notification Icon" className="notification-icon"/>
            <div className="notification-details">
              <div className='title-and-time'>
              <div className="notification-title">{notification.title}</div>
              <div className="notification-datetime">{notification.datetime}</div>
              </div>
              <div className="notification-text">{notification.text}</div>
              <button className="notification-button">View Case</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};